var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useQuery } from '@apollo/client';
import { Card, CardContent } from '@mui/material';
import { ActivityValidationLevels } from 'common/enums/activity/activity-validation-levels.enum';
import { ActivityValidationStates } from 'common/enums/activity/activity-validation-states.enum';
import { ActivityValidationTypes } from 'common/enums/activity/activity-validation-types.enum';
import { ACTIVITY_VALIDATIONS } from 'common/graphql/queries/activity-validations/activityValidations';
import PageSimple from 'components/PageLayouts/simple/PageSimple';
import { useEffect, useState } from 'react';
import ActivityValidationsList from './ActivityValidationsList';
import ActivityValidationsPageFilters from './ActivityValidationsPageFilters';
var ActivityValidationsPage = function () {
    var _a = useState({
        userId: undefined,
        validationState: [ActivityValidationStates.PENDING],
        validationLevel: 'ALL',
        targetEntityId: undefined
    }), filters = _a[0], setFilters = _a[1];
    var _b = useQuery(ACTIVITY_VALIDATIONS, {
        fetchPolicy: 'network-only',
        variables: {
            userId: filters.userId,
            validationType: ActivityValidationTypes.Manual,
            validationState: filters.validationState[0] === 'ALL' ? undefined : filters.validationState[0],
            validationLevel: filters.validationLevel === 'ALL' ? undefined : filters.validationLevel,
            targetEntityId: filters.targetEntityId,
            limit: 10,
            offset: 0
        }
    }), data = _b.data, loading = _b.loading, fetchMore = _b.fetchMore, refetch = _b.refetch;
    useEffect(function () {
        if (filters.validationLevel === ActivityValidationLevels.Base || filters.validationLevel === 'ALL') {
            setFilters(function (filters) {
                return __assign(__assign({}, filters), { targetEntityId: undefined });
            });
        }
    }, [filters.validationLevel]);
    return (_jsx(PageSimple, { header: _jsx(Card, { children: _jsx(CardContent, { children: _jsx("p", __assign({ className: "tw-page-container-header-title" }, { children: "\u0412\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438 \u0442\u0440\u0435\u043D\u0438\u0440\u043E\u0432\u043E\u043A" }), void 0) }, void 0) }, void 0), filterPanel: _jsx(ActivityValidationsPageFilters, { filters: filters, setFilters: setFilters, refetch: refetch }, void 0), content: _jsx(ActivityValidationsList, { activityValidations: data === null || data === void 0 ? void 0 : data.activityValidations, isLoading: loading, loadMore: function () {
                var _a;
                var currentLength = ((_a = data === null || data === void 0 ? void 0 : data.activityValidations) === null || _a === void 0 ? void 0 : _a.length) || 0;
                fetchMore({
                    variables: {
                        offset: currentLength
                    }
                });
            } }, void 0), innerScroll: false }, void 0));
};
export default ActivityValidationsPage;
